// Shared per-tab empty-state copy/illustration for the Courses panel, used by
// both the Accelerate dashboard and the My Courses page. The `cta` action is
// wired by each consumer (both navigate to Add Courses).
import stampArt from '@/assets/images/empty-transcript.svg';
import browseArt from '@/assets/images/empty-no-courses.svg';

// Current / Upcoming share the "browse courses" empty state (Figma 1123-75810 / 76509).
const BROWSE = {
  title: 'No active course enrollments',
  message:
    "You're not currently enrolled in any courses. Browse available courses to continue your learning journey and work toward your academic and career goals.",
  image: browseArt,
  ctaLabel: 'View available courses'
};

const STATES = {
  all: BROWSE,
  current: BROWSE,
  upcoming: BROWSE,
  // Past empty state (Figma 1123-74453) — encouraging, no CTA. Transcript is
  // the tab's headline content, so its copy carries the whole tab.
  past: {
    title: 'No courses ready for transcript',
    message:
      'Keep up the great work! Once you complete your current courses with passing grades, they will appear here to be added to your official transcript.',
    image: stampArt
  }
};

export function emptyStateFor(tab) {
  return STATES[tab] || STATES.all;
}
